<div class="content-area">
  <div class="container-fluid">

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="mb-0">Painel de Estoque</h3>
      <div>
        <button class="btn btn-outline-primary me-2" (click)="goToCadastro()">
          <i class="bi bi-plus-circle me-2"></i>Novo Item
        </button>
        <button class="btn btn-primary">
          <i class="bi bi-download me-2"></i>Exportar CSV
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="carregando" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p class="mt-2 text-muted">Carregando dados do estoque...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="erro && !carregando" class="alert alert-danger d-flex align-items-center" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      <span>{{ erro }}</span>
    </div>

    <!-- Content -->
    <ng-container *ngIf="!carregando && !erro && dashboardData">

      <!-- Cards de Métricas -->
      <div class="row g-4 mb-4">

        <!-- Total em Estoque -->
        <div class="col-md-6 col-lg-3">
          <div class="card shadow-sm h-100">
            <div class="card-body d-flex align-items-center">
              <div class="me-3">
                <i class="bi bi-archive-fill" style="font-size: 2rem; color: #6c757d"></i>
              </div>
              <div>
                <div class="text-sm text-muted">Total em Estoque</div>
                <div class="h5 mb-0 fw-bold">{{ dashboardData.metrics.totalEstoque | number }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Entradas 30d -->
        <div class="col-md-6 col-lg-3">
          <div class="card shadow-sm h-100">
            <div class="card-body d-flex align-items-center">
              <div class="me-3">
                <i class="bi bi-arrow-down-left" style="font-size: 2rem; color: #198754"></i>
              </div>
              <div>
                <div class="text-sm text-muted">Entradas (30d)</div>
                <div class="h5 mb-0 fw-bold">{{ dashboardData.metrics.entradas30d | number }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Saídas 30d — em breve -->
        <div class="col-md-6 col-lg-3">
          <div class="card shadow-sm h-100 border-secondary-subtle">
            <div class="card-body d-flex align-items-center">
              <div class="me-3">
                <i class="bi bi-arrow-up-right" style="font-size: 2rem; color: #adb5bd"></i>
              </div>
              <div>
                <div class="text-sm text-muted">Saídas (30d)</div>
                <div class="d-flex align-items-center gap-2">
                  <span class="h5 mb-0 fw-bold text-muted">—</span>
                  <span class="badge bg-secondary-subtle text-secondary border border-secondary-subtle"
                    style="font-size: 0.65rem;">Em breve</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Itens Críticos -->
        <div class="col-md-6 col-lg-3">
          <div class="card shadow-sm h-100">
            <div class="card-body d-flex align-items-center">
              <div class="me-3">
                <i class="bi bi-exclamation-triangle-fill" style="font-size: 2rem; color: #ffc107"></i>
              </div>
              <div>
                <div class="text-sm text-muted">Itens Críticos</div>
                <div class="h5 mb-0 fw-bold">{{ dashboardData.metrics.itensCriticos | number }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Gráfico + Tabela -->
      <div class="row g-4">

        <!-- Gráfico de Distribuição -->
        <div class="col-lg-4">
          <div class="card shadow-sm">
            <div class="card-header bg-light border-bottom">
              <h6 class="card-title mb-0">Distribuição por Condição</h6>
            </div>
            <div class="card-body" style="height:280px;">
              <div *ngIf="dashboardData.distribution.length === 0" class="text-center text-muted pt-4">
                <i class="bi bi-pie-chart" style="font-size: 2rem;"></i>
                <p class="mt-2">Sem dados de distribuição</p>
              </div>
              <div class="chart-wrapper mt-3" style="height:220px;" *ngIf="dashboardData.distribution.length > 0">
                <canvas baseChart [data]="distribuicaoEstoqueChartData" [options]="distribuicaoEstoqueChartOptions"
                  chartType="pie">
                </canvas>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabela de Itens -->
        <div class="col-lg-8">
          <div class="card shadow-sm">
            <div class="card-header bg-light border-bottom">
              <h6 class="card-title mb-0">Itens no Estoque</h6>
            </div>
            <div class="card-body p-0">

              <div *ngIf="dashboardData.itens.length === 0" class="text-center text-muted py-5">
                <i class="bi bi-inbox" style="font-size: 2rem;"></i>
                <p class="mt-2">Nenhum item encontrado no estoque.</p>
              </div>

              <div class="table-responsive" *ngIf="dashboardData.itens.length > 0">
                <table class="table table-hover align-middle mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Patrimônio</th>
                      <th>Descrição</th>
                      <th>Categoria</th>
                      <th>Marca</th>
                      <th>Modelo</th>
                      <th>Condição</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of dashboardData.itens">
                      <td><strong>#{{ item.exbePatrimonioId }}</strong></td>
                      <td>{{ item.descricao }}</td>
                      <td>{{ item.categoria?.nome ?? '—' }}</td>
                      <td>{{ item.marca?.nome ?? '—' }}</td>
                      <td>{{ item.modelo?.nome ?? '—' }}</td>
                      <td>
                        <span class="badge rounded-pill" [class.bg-success]="item.tipoCondicaoBens?.nome === 'Novo'"
                          [class.bg-info]="item.tipoCondicaoBens?.nome === 'Bom'"
                          [class.bg-warning]="item.tipoCondicaoBens?.nome === 'Danificado'"
                          [class.bg-danger]="item.tipoCondicaoBens?.nome === 'Perdido'"
                          [class.bg-secondary]="!item.tipoCondicaoBens?.nome">
                          {{ item.tipoCondicaoBens?.nome ?? 'N/A' }}
                        </span>
                      </td>
                      <td>
                        <span class="badge rounded-pill" [class.bg-success-subtle]="item.ativo === true"
                          [class.text-success-emphasis]="item.ativo === true"
                          [class.bg-secondary-subtle]="item.ativo === false || item.ativo === null"
                          [class.text-secondary-emphasis]="item.ativo === false || item.ativo === null">
                          {{ item.ativo ? 'Ativo' : 'Inativo' }}
                        </span>
                      </td>
                      <td>
                        <button class="btn btn-sm btn-outline-secondary me-1" title="Visualizar">
                          <i class="bi bi-eye"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-primary" title="Editar">
                          <i class="bi bi-pencil"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>
    </ng-container>

  </div>
</div>